(function() {
  'use strict';

  function init() {
    /* Premier .product__accordion = la description produit */
    var firstAccordion = document.querySelector('.product__accordion');
    if (!firstAccordion) return;
    /* 01/11 : la description est désormais un accordéon fermé (#Details-hb-desc), on ne le force plus ouvert */
    if (firstAccordion.querySelector('#Details-hb-desc')) return;

    /* Marquer cet accordéon pour le CSS */
    firstAccordion.classList.add('description--see-more');

    /* Forcer l'ouverture du <details> */
    var details = firstAccordion.querySelector('details');
    if (details) details.setAttribute('open', '');

    var content = firstAccordion.querySelector('.accordion__content');
    if (!content) return;

    /* Petit délai pour laisser le layout se calculer */
    requestAnimationFrame(function() {
      var isOverflowing = content.scrollHeight > content.clientHeight + 2;
      if (!isOverflowing) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'description-see-more-btn';
      btn.textContent = 'See more';
      btn.setAttribute('aria-expanded', 'false');

      /* Insérer le bouton après le contenu, dans le <details> */
      content.parentNode.insertBefore(btn, content.nextSibling);

      btn.addEventListener('click', function() {
        var expanded = content.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'See less' : 'See more';
        btn.setAttribute('aria-expanded', String(expanded));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
